import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ml_asset } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { REMOTE__generation_create } from '@/state/generation/entity/REMOTE__generation_create';
import { set_current_generation } from '@/utils/utils_client_workspace_child_entity_viewers';
import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { logi } from '@shared/utils/utils_logs';
import { useMemo } from 'react';

interface PROPS {}

export function G_HEADER__generations_history_button_create_new({}: PROPS) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);

  const graph_new = useMemo(() => get_graph_new(), [ml_assets_map]);

  /*
   * STATE
   */

  /*
   * EFFECTS
   */

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = new DTO_REQUEST__generation_create();
    request.generation_id_previous = ENUM__string_id_empty.OBJECT_ID;
    request.graph = graph_new;
    request.user_task_id = generation_current.user_task_id;

    /*
     *
     */
    let action_result = await dispatch(REMOTE__generation_create(request));

    if (typeof action_result.payload != 'string') return;

    let generation_id = action_result.payload;

    assert_string_object_id(generation_id);

    await set_current_generation(generation_id);
  }
  /*
   * METHODS
   */

  function get_graph_new() {
    //todo:implement

    logi('todo: not implemented');
    return DTO_GRAPH__instance.CREATE_NEW();

    // let ml_asset_map_by_hash = DTO__ml_asset.map_by_hash(Array.from(ml_assets_map.values()));

    // let out = GENERATION_TOOL__sd1__txt2img();

    // out.hash_clear();

    // return out;
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <></>;
  if (graph_new.is_stub()) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="full-6"
      {...{ onClick }}
      className=""
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={ICON__plus}
    />
  );
}
